export default __webpack_public_path__ + "static/media/global-footprint-banner.f002c728.jpg";